import { render, staticRenderFns } from "./CustomerEntityTypeSelection.vue?vue&type=template&id=5e238566"
import script from "./CustomerEntityTypeSelection.vue?vue&type=script&lang=js"
export * from "./CustomerEntityTypeSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports